import { Box, Stack } from "@mui/material"
import RichTable from "../components/table"
import CodeView from "./code-view"
import OtherProps from "./other-props"
import { MainStoreProvider } from "./store"



const ImacrosGenerator = () => {

  return (
    <MainStoreProvider>
      <Stack sx={{ flexGrow: 1, spacing: 1, overflow: "hidden" }}>
        <OtherProps/>
        <Box sx={{ display: "flex", alignItems: "stretch", flexGrow: 1, overflow: "hidden" }}>
          <RichTable/>
          <CodeView/>
        </Box>
      </Stack>
    </MainStoreProvider>
  )

}

export default ImacrosGenerator